import React, { useCallback } from 'react';
import { Button } from '@ui/buttons';
import { Icon } from '@ui/Icon';
import { makeStyles } from 'tss-react/mui';
import { openDataTableDialog } from '@features/data-table/dialog';

export const DataTableViewFooter: React.FC = () => {
  const { classes } = useStyles();

  const handleAddDataTable = useCallback(async () => {
    await openDataTableDialog();
  }, []);

  return (
    <div className={classes.header}>
      <Button
        variant="outlined"
        size="small"
        color="secondary"
        startIcon={<Icon category="mui" icon="Add" size="small" />}
        onClick={handleAddDataTable}
        minWidth={140}
      >
        Add Data Table
      </Button>
    </div>
  );
};

const useStyles = makeStyles()(({ spacing }) => ({
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(4),
  },
}));
